import {StepHandler} from '../utils/StepHandler';
export class Application extends StepHandler(Function)  {
}
